import React from "react";
import { Button } from "react-bootstrap";
import SelectDropdown from "../../components-react/SelectDropdown";
import { callInitiatedStatuses } from "../../common-data/DropdowData";

const CampaignFilters = (props) => {
  const { onClickReset, filters, setFilters } = props || {};

  return (
    <div
      className={`cmnFilterStructureContainer`}
      style={{ marginTop: "1rem" }}
    >
      <div className="filterblock filter-border">
        <div className="filterHeadingNBtn">
          <h5 className="filterHeading">All Filters</h5>

          <div className="filterHeadingBtnBlock lastOne">
            <Button variant="outline-danger" onClick={onClickReset}>
              Reset Filter
            </Button>
          </div>
        </div>

        <div className={`filtersDropdown `}>
          <div
            className={`commonWrapper dropdownCommonWrapper gridSpanTwo ${
              filters?.selStatus?.value && "redBorderRedText"
            }`}
          >
            <SelectDropdown
              options={callInitiatedStatuses}
              selectedOption={filters?.selStatus}
              setSelectedOption={(selectedValue) =>
                setFilters({
                  ...filters,
                  selStatus: selectedValue,
                })
              }
              name="Status"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default CampaignFilters;
